module.exports = __webpack_public_path__ + "static/img/co.th.truemoney.wallet.cb1c8f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bank_logo/co.th.truemoney.wallet.svg
// module id = +dsa
// module chunks = 27 28